import { THEME_PRESETS, DEFAULT_THEME } from '@/styles/themes'

/**
 * 根据主题标识应用 CSS 变量到 document.documentElement
 * @param {string} themeName - 主题标识符，如 'default'、'brand_a'
 */
export function applyTheme(themeName) {
  const preset = THEME_PRESETS[themeName]
  if (!preset) {
    console.warn(`[Theme] Unknown theme "${themeName}", falling back to "${DEFAULT_THEME}"`)
  }
  const theme = preset || THEME_PRESETS[DEFAULT_THEME]
  const root = document.documentElement
  Object.entries(theme).forEach(([varName, value]) => {
    root.style.setProperty(varName, value)
  })
}

/**
 * 重置主题为 CSS 中 :root 声明的默认值
 */
export function resetTheme() {
  const root = document.documentElement
  const defaultPreset = THEME_PRESETS[DEFAULT_THEME]
  Object.keys(defaultPreset).forEach((varName) => {
    root.style.removeProperty(varName)
  })
}
